import { useRoutes } from 'react-router-dom'
import { Provider } from 'react-redux'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'
import enGB from 'date-fns/locale/en-GB'
import { CssBaseline } from '@mui/material'
import { useEffect } from 'react'
import ThemeProvider from './theme/ThemeProvider'
import router from './router'
import store from './store'
import { isLoggedIn, interceptor } from './utils'
import AnalyticsManager from './analytics/AnalyticsManager'
import MarketingAttributionCapture from './marketing/MarketingAttributionCapture'

interceptor(store)

function App() {
  const content = useRoutes(router(isLoggedIn()))

  // Initialize AnalyticsManager on app startup
  useEffect(() => {
    AnalyticsManager.shared.initialize()
  }, [])

  return (
    <Provider store={store}>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <CssBaseline />
          <MarketingAttributionCapture />
          {content}
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  )
}
export default App
